export const SET_ACTIVE_USER_ID = "SET_ACTIVE_USER_ID";
export const SET_TYPING_VALUE = "SET_TYPING_VALUE";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const DELETE_CHAT = "DELETE_CHAT";
export const EDIT_CHAT = "EDIT_CHAT";

// auth

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";
export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILURE = "REGISTER_FAILURE";

// new user management constant
export const SET_USER = "SET_USER";
